import { render, staticRenderFns } from "./AccountPendingInvitesItem.vue?vue&type=template&id=84814a00&"
import script from "./AccountPendingInvitesItem.vue?vue&type=script&lang=js&"
export * from "./AccountPendingInvitesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports